















import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
export default Vue.extend({
  name: 'AdminClientSessionBar',
  computed: {
    ...mapGetters('client', ['client']),
    ...mapState('user', ['clientId', 'isClientSession']),
    companyName() {
      return this.client.companyName ? this.client.companyName : 'a client';
    },
    isTestClient() {
      return this.client.isTestClient;
    },
    localTime() {
      return moment.tz(new Date(), this.client.timeZone).format('hh:mm A');
    }
  }
});
